/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Start/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import ShadowButton from 'DesignSystem/ShadowButton/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Start({
  children,
  viewPath = "/App/Account/Start"
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<button
  data-testid="Start.Vertical"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../LastNameFirstLetter'))}
 {...isHoveredBind}
 style={{'--o-1-5MlDR': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<ShadowButton
  viewPath={`${viewPath}/ShadowButton`}
/>
</button>
{children}
</React.Fragment>)
}